import React, {useContext, useEffect, useState} from 'react';
import PageIntroSection from "../components/PageIntroSection/PageIntroSection";
import RestaurantItem from "../components/Restourant-item/RestaurantItem";
import {LangContext} from "../App";
import {axios} from "../axios";
import hotelImage from "../assets/images/test/hotelImage.jpg";
import Seo from "../components/Seo/Seo";

const content = {
    en: {
        heroTitle: "Restaurants in Armenia",
        heroText: "Browse restaurants and find a place to eat during your trip to Armenia.",
    },
    de: {
        heroTitle: "Restaurants in Armenien",
        heroText: "Durchsuchen Sie die Restaurants und finden Sie einen Ort zum Essen während Ihrer Reise nach Armenien.",
    },
};

const Restaurant = () => {
    const [data,setData] = useState([])
    const lang = useContext(LangContext)
    const t = content[lang] || content.en
    useEffect(()=>{
        axios.get(`${lang}/restaurant`)
            .then(res => setData(res.data.tours))
            .catch(() => setData([]))
    },[lang])
    return (
        <div className='restaurant'>
            <Seo pageKey="restaurants" />
            <PageIntroSection title={t.heroTitle}
                              image={hotelImage}
                              text={t.heroText}
            />
            <div className="center-wrapper">
                <div className="restaurant-list">
                    {data.map(e => <RestaurantItem path='restaurant-page' key={e.id} tour={e}/>)}
                </div>
            </div>
        </div>
    );
};

export default Restaurant;